import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouteReuseStrategy } from '@angular/router';
import { NoReuseStrategy } from './app-routing.module';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MatMenuModule } from "@angular/material/menu";
import { MatIconModule } from "@angular/material/icon";
import { MatDividerModule } from "@angular/material/divider";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from "@angular/material/input";
import { MatDialogModule } from '@angular/material/dialog';
import { MatStep, MatStepperModule } from '@angular/material/stepper'; 
import {
 MAT_DIALOG_DATA,
 MatDialog,
 MatDialogActions,
 MatDialogClose,
 MatDialogContent,
 MatDialogRef,
 MatDialogTitle,
} from '@angular/material/dialog';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from "@angular/material/select";
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTooltip } from '@angular/material/tooltip'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { SpinnerComponent } from './spinner/spinner.component';
import { LoadingInterceptor } from './loading.interceptor';
import { VersionCheckInterceptor } from './version-check.interceptor';
import { LoginComponent } from './login/login.component';
import { AdminUsersComponent } from './admin-users/admin-users.component';
import { AdminClientsComponent } from './admin-clients/admin-clients.component';
import { AdminBeneficiariesComponent } from './admin-beneficiaries/admin-beneficiaries.component';
import { ProbateListComponent } from './probate-list/probate-list.component';
import { ReadingComponent } from './reading/reading.component';
import { ReportingComponent } from './reporting/reporting.component';
import { HomeComponent } from './home/home.component';
//import { CharityDatabaseComponent } from './charity-database/charity-database.component';
import { CharityDetailsComponent } from './charity-details/charity-details.component';
//import { CharityDetailsDialogComponent } from './charity-details-dialog/charity-details-dialog.component';
import { UsersComponent } from './users/users.component';
import { MatTableModule, MatRow, MatHeaderRow, MatCell, MatHeaderCell, MatFooterRow, MatFooterCell } from '@angular/material/table'
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMomentDateModule, MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { HttpClientModule } from '@angular/common/http';
import { MatSortModule } from '@angular/material/sort';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { AdminClientSubscriptionsComponent } from './admin-client-subscriptions/admin-client-subscriptions.component';
import { AdminSubscriptionItemsComponent } from './admin-subscription-items/admin-subscription-items.component';
import { AdminSubscriptionItemDialogComponent } from "./admin-subscription-item-dialog/admin-subscription-item-dialog.component"; 
import { AdminBeneficiaryDialogComponent } from './admin-beneficiary-dialog/admin-beneficiary-dialog.component';
import { ReportsComponent } from './reports/reports.component';
import { FinanceInvoiceReportComponent } from './finance-invoice-report/finance-invoice-report.component';
import { ProbateStatusReportComponent } from './probate-status-report/probate-status-report.component';
import { ClientPortalComponent } from './client-portal/client-portal.component';
import { ClientPortalLoginComponent } from './client-portal-login/client-portal-login.component';
export const MY_MOMENT_FORMATS = {
 parse: {
 dateInput: 'DD/MM/YYYY',
 timeInput: 'HH:mm'
 },
 display: {
 dateInput: 'DD/MM/YYYY',
 timeInput: 'HH:mm',
 monthYearLabel: 'MMM YYYY',
 dateA11yLabel: 'LL',
 monthYearA11yLabel: 'MMMM YYYY',
 timeOptionLabel: 'HH:mm',
 }
};

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    SpinnerComponent,
    AdminUsersComponent,
    AdminClientsComponent,
    AdminBeneficiariesComponent,
    AdminClientSubscriptionsComponent,
    AdminSubscriptionItemsComponent,
    AdminSubscriptionItemDialogComponent,
    ReadingComponent,
    ReportingComponent,
    HomeComponent,
    //CharityDatabaseComponent,
    CharityDetailsComponent,
    //CharityDetailsDialogComponent,
    UsersComponent,
    ProbateListComponent,
    ReportsComponent,
    FinanceInvoiceReportComponent,
    ProbateStatusReportComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MatToolbarModule,
    MatMenuModule,
    MatIconModule,
    MatDividerModule,
    MatTableModule, MatRow, MatHeaderRow, MatCell, MatHeaderCell, MatFooterRow, MatFooterCell,
    MatCheckboxModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatStepperModule,
    MatDialogActions,
    MatStep,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatFormFieldModule,
    MatMomentDateModule,
    MatDatepickerModule,
    MatExpansionModule,
    MatSelectModule,
    MatPaginatorModule,
    MatSortModule,
    MatAutocompleteModule,
    MatTooltip,
    MatTooltipModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    OverlayModule,
    DragDropModule,
    ScrollingModule,
    PdfViewerModule,
    AdminBeneficiaryDialogComponent,
    ClientPortalComponent,
    ClientPortalLoginComponent
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: VersionCheckInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    { provide: RouteReuseStrategy, useClass: NoReuseStrategy },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_MOMENT_DATE_ADAPTER_OPTIONS] },
    { provide: MAT_DATE_FORMATS, useValue: MY_MOMENT_FORMATS }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
